<template>
    <v-card>
        <v-toolbar dark color="primary">
                <v-toolbar-title>
                    <div style="color: white; font-weight: bold;">{{ title }}</div>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <slot name="toolbarExtension"></slot>
                <v-btn icon dark :title="$t('button.close')" @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
            <div class="text-overline">{{ intro }}</div>
            <v-list two-line height="50vh" style="overflow-y: auto;">
                <v-list-item v-for="(item, i) in items" :key="`HELPITEM-${i}`">
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                        <v-list-item-subtitle class="help-description">{{ item.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "HelpCard",
    props: {
        items: {
            type: Array,
            required: true
        },
        intro: {
            type: String, 
            default() {
                return this.$t('helpCard.defaultIntro');
            }
        },
        title: {
            type: String, 
            default() {
                return this.$t('helpCard.defaultTitle');
            }
        }
    },
}
</script>
<style scoped>
.help-description {
    white-space: pre-line !important;
    line-height: 1.5 !important;
}
</style>

<style>
/* Estilo global para garantir que funcione mesmo dentro do Vuetify */
.v-list-item__subtitle.help-description {
    white-space: pre-line !important;
    line-height: 1.5 !important;
}
</style>